module.exports = __webpack_public_path__ + "static/media/success.03963d9f.svg";